import React from 'react';
import '../../Styles/fonts.css';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import './Header.css';
import Header1 from '../Header1';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <>
      <Navbar expand="lg" className="bgcolor">
        <Container fluid className="header-container">

          <Navbar.Brand href="#" className="d-flex align-items-center header-left">
            <img
              src="/rp-logo-image.jpg"
              alt="RP Smart Energy Logo"
              className="logoimg"
            />
            <div className="logo-text">
              <h6 className="brand-heading-glow mb-0 fw-bold rp-title">RP SMART ENERGY</h6>
              <small className="rp-subtitle" style={{paddingLeft:80, textDecoration:'none'}}>Be Smart, Be Bright</small>
            </div>
          </Navbar.Brand>

          <div className="user-actions-container">
            <div className="loginregis d-flex align-items-center">
              <i className="fa-solid fa-user me-2"></i>
              <p className="mb-0">Login/Register</p>
            </div>

            <Link to="/products" className="cart-link">
              <button type="button" className="cartbtn">
                <i className="fa-solid fa-cart-shopping"></i>
              </button>
            </Link>

            <Button variant="outline-warning" className="searchbtn">
              <i className="fa-solid fa-magnifying-glass"></i>
            </Button>
          </div>
        </Container>
      </Navbar>
      <Header1 />
    </>
  );
}

export default Header;